import { Gap } from 'lib/components/styles/layout';
import { SubHeading } from 'lib/components/styles/typography';
import { ReactComponent as VisibilityMessageIcon } from 'assets/icons/visibility/message.svg';
import React from 'react';
import { Button } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';

interface IProps {
  openHowToShareModal: () => void;
  message: string;
}
export const VisibilityMessage = ({ message, openHowToShareModal }: IProps) => {
  const { t } = useTranslation();
  return (
    <Gap style={{ height: '100%' }}>
      <Gap width='100%' alignItems='center' justifyContent='center' gap='24px'>
        <VisibilityMessageIcon />
        <SubHeading textAlign='center'>{message}</SubHeading>
        <Button
          text={t('How to Share?')}
          variant='white'
          onClick={openHowToShareModal}
        />
      </Gap>
    </Gap>
  );
};
